export default __webpack_public_path__ + "static/media/bizDAMz_Intro_Video.9ca2f78a.mp4";